import { Component, Input, OnInit } from "@angular/core";

@Component({
    selector: 'app-tab-title',
    templateUrl: './tab-title.component.html',
    styleUrls: ['./tab-title.component.scss'],
    standalone: false
})
export class TabTitleComponent implements OnInit {
  @Input() title: string = '';
  @Input() icon: string = '';

  constructor() { }

  ngOnInit(): void {
  }

}
